import React from "react";
import { Button, dialog } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import ProcessPayrollPresenter from "./ProcessPayrollPresenter";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import { Space, DatePicker } from "antd";
import FileUpload from "./FileUpload";
import FormPayrollPage from "./form-payroll/FormPayrollPage";
import { getMonthIndex } from "./other-functions/OtherFunctions";
import InputFactory from "../../../components/InputFactory";
import ModalContent from "./table-payroll/ModalContent";
import Progress from "../../../components/Progress";
import {
  isAddendumBackPayItem,
  isBackPayItem,
} from "./helper-payroll/constants/payrollConstants";

class ProcessPayrollPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ProcessPayrollPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      selected: [],
      jobTypes: [],
      payItemsOption: [],
      // employees: [],
      incentivesLists: [],
      salaryLevel: [],
      attendance: [],
      filterEmployees: [],
      natureOfFunction: "",
      monthIndex: 0,
      datePicked: null,
      csvData: null,
      limit: 50,
      current: 1,
      count: 0,
      payrollTypes: "",
      payItems: "",
      payrollTypeVal: "",
      jobTypeVal: "",
      payItemVal: "",
      cutOffVal: "",
      jobTypeID: "",
      incentiveId: "",
      isJobTypeshow: true,
      isPayItemShow: false,
      isFloatingForm: false,
      personelAirportCount: {},
      payrollCode: "",
      percentage: 0,
      periodCovered: null,
      selectedYear: "",
      isModalContent: false,
      monthFrom: "",
      monthTo: "",
      twentyPercentYear: "",
      joData: [],
      panelState: {},
      caseName: "",
      sampleEmployee: [],
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
 
    const [
      // employmentTypes,
      seperated,
      incentives,
      // taxTable,
      // serviceRecords,
      natureOfFunctions,
      // employees,
      payrollLayouts,
      // employees,
      // airportAssign
    ] = await Promise.all([
      findObjectUseCase().execute("seperated", {
        include: ["employee"]
      }),
      findObjectUseCase().execute("incentive", {
        keys: ["allowanceType"],
        include: ["allowanceType"],
      }),
      // findObjectUseCase().execute("tax-table", {
      //   keys: ["initial", "percent"],
      // }),
      // findObjectUseCase().execute("service_record", {
      //   keys: ["cause", "percent"],
      // }),
      findObjectUseCase().execute("nature_functions", {
        where: {
          id: "0c8ff78c-352b-42ae-8bc2-aecf8f740c66",
        },
        include: ["payCode"],
        keys: ["payCode"],
      }),
      findObjectUseCase().execute("payroll_layouts", {
        keys: ["footer", "header", "name"],
      }),
      // findObjectUseCase().execute("employees", {
      //   include: ["all"],
      //   // keys: ["Firstname", "Middlename", "surname", "accountNumber", "agency", "allowance", "email", "employmentType", "gsis", "isGraduated", "isSubmitted", "nonRegPosition", "payrollRelation", "percentTag", "selectedSchedule", "supervisor", "twentyFourSeven"],
      //  where: {
      //   id: "221770cc-ae3f-4e7e-bdde-b10daf3f9208"
      //  },
      //   sort: { surname: 1 },
      // }),
      // findObjectUseCase().execute("employees", {
      //   where: {
      //     id: { $in: [
      //       // "8d2b6c2d-2c23-4704-9d65-48de3d230c56", 
      //       // "91bd6596-d35e-4cb5-80e0-b3f7f9912ac3",
      //       // "086278c3-b30f-43e5-86c0-de753293f9e8",
      //       // "8041edc5-ab5c-436f-8852-64ce06653c8b",
      //       // "086278c3-b30f-43e5-86c0-de753293f9e8",
      //       // "bc8797eb-9aca-46f6-9411-ba192102239c",
      //       // "c6c0a89e-70c6-4225-b8f3-6ca8e8272e2c",
      //       "8041edc5-ab5c-436f-8852-64ce06653c8b"
      //     ] }
      //   },
      //   include: ["all"],
      // }),
    ]);

    // console.log("employees", employees);




    const incentivesLists = incentives.map((item) => ({
      label: item?.allowanceType?.AllowanceType,
      value: item?.allowanceType?.AllowanceType,
      id: item.id,
    }));


    try {
      this.setState((prevState) => {
        const next = {
          panelState: {
            ...prevState.panelState,
            payrollHeader: { value: payrollLayouts?.[0] },
          },
          incentivesLists,
          natureOfFunction: natureOfFunctions[0]?.payCode.amount,
        };
        if (prevState.payrollTypes === "SP") {
          next.payItemsOption = this.presenter.getPayItems({
            payrollTypes: "SP",
            jobTypeVal: prevState.jobTypeVal,
            incentivesLists,
          });
        }
        return next;
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevState.datePicked !== this.state.datePicked ||
      prevState.selected !== this.state.selected
    ) {
      const { datePicked } = this.state;
      const cases = this.presenter.checkCase();

      const monthIndex = getMonthIndex(datePicked);

      this.setState({ monthIndex, caseName: cases?.case });
    }
  }

  getCollectionName() {
    return "employees";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      loading,
      count,
      limit,
      current,
      selected,
      // jobTypes,
      jobTypeVal,
      payrollTypes,
      payrollTypeVal,
      payItems,
      payItemVal,
      payItemsOption,
      jobTypeID,
      joData,
    } = this.state;

    const isGpBasic = payrollTypes === "BP" && payItems == "General Payroll";
    const isJo =
      payrollTypes === "BP" &&
      jobTypeVal === "Job Order" &&
      payItemVal === "Salary";

    const canGenerate = Boolean(payrollTypes && jobTypeVal && payItemVal);

    const filteredObj = isGpBasic
      ? objects
      : isJo
      ? this.state.joData
      : this.state.filterEmployees;

    const tableObjects =
      isAddendumBackPayItem(payItemVal) ||
      payItemVal === "Newly-Hired" ||
      isBackPayItem(payItemVal) ||
      payrollTypes === "IP" ||
      payrollTypes === "SP"
        ? selected
        : filteredObj;

    // const filteredJobTypes =
    //   payrollTypes === "AP"
    //     ? jobTypes.filter((jt) => jt.label !== "Job Order")
    //     : jobTypes;

    const { payrollLabel } = this.presenter;
    const { RangePicker } = DatePicker;

    if (!schema) return <Progress />;
    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "agency" &&
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname"
      //     fields !== "office" &&
      //     fields !== "division"
    );

    const selectConfigs = [
      {
        key: "payrollTypeVal",
        placeholder: "Payroll Type",
        options: payrollLabel,
      },
      // {
      //   key: "jobTypeVal",
      //   placeholder: "Employment Type",
      //   options: filteredJobTypes,
      // },
    ];

    // if (this.state.isJobTypeshow) {
    //   selectConfigs.push({
    //     key: "jobTypeVal",
    //     placeholder: "Employment Type",
    //     options: jobTypes,
    //   });
    // }

    // payItemVal will be rendered separately after jobTypeVal
    // if (this.state.isPayItemShow) {
    //   selectConfigs.push({
    //     key: "payItemVal",
    //     placeholder: "Pay Items",
    //     options: payItemsOption,
    //   });
    // }

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Generate Payroll
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                {/* <Search
                  schemas={this.getSchemas()}
                  onSubmit={(value) => this.presenter.searchSubmit(value)}
                  fields={schema.fields}
                  searchFields={["agency", "Firstname", "surname", "Middlename"]}
                /> */}
                 <div className="row p-1">
                  {Object.keys(schema.filters || {})
                    .filter(
                      (field) =>
                        ![
                          "earnings",
                          "sex",
                          "civil",
                          "month",
                          "year",
                          "lengthOfService",
                          "employmentType",
                        ].includes(field)
                    )
                    .map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div className="col-lg-4 p-1" key={field}>
                          <InputFactory
                            key={field}
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        </div>
                      );
                    })}
                </div>
              </CardView>

              <div style={{ marginTop: "10px", width: "100%" }}>
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center mb-2">
                    <h4 className="text-primary">Generate Payroll</h4>
                  </div>

                  <div className="row">
                    {/* payrollTypeVal */}
                    {selectConfigs.map(({ key, placeholder, options }) => (
                      <div key={key} className="col-md-3 mt-1">
                        <SearchSelect
                          value={this.state[key]}
                          placeholder={placeholder}
                          onChange={(value) =>
                            this.presenter.handleSelectChange(key, value)
                          }
                          onClickClear={() =>
                            this.presenter.handleSelectChange(key, "")
                          }
                          options={options}
                        />
                      </div>
                    ))}
                    {/* jobTypeVal (employmentType) */}
                    {Object.keys(schema.fields || {})
                      .filter((field) =>
                        ["employmentType"].includes(field)
                      )
                      .map((field) => {
                        let { type, where: existingWhere, ...options } = schema.fields[field];
                        const additionalWhere = payrollTypes === "AP" 
                          ? { name: { $ne: "Job Order" } }
                          : {};
                        const mergedWhere = { ...existingWhere, ...additionalWhere };
                        
                        return (
                          <div className="col-md-3 mt-1" key={field}>
                            <InputFactory
                              key={`${field}-${payrollTypes || 'empty'}`}
                              type={type}
                              field={field}
                              where={mergedWhere}
                              keys={["name"]}
                              onChange={(value) =>
                                this.presenter.handleSelectChange("jobTypeVal", value)
                              }
                              {...options}
                            />
                          </div>
                        );
                      })}
                    {/* payItemVal */}
                    {this.state.isPayItemShow && (
                      <div className="col-md-3 mt-1">
                        <SearchSelect
                          value={this.state.payItemVal}
                          placeholder="Pay Items"
                          onChange={(value) =>
                            this.presenter.handleSelectChange("payItemVal", value)
                          }
                          onClickClear={() =>
                            this.presenter.handleSelectChange("payItemVal", "")
                          }
                          options={payItemsOption}
                        />
                      </div>
                    )}
                    {selected.length > 0 && (
                    <div className="col-md-3 d-flex align-items-center">
                      <p className="mb-0">Selected Employee(s): <b>{selected.length}</b></p>
                    </div>
                    )}
                  </div>
                  <hr></hr>

                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex flex-wrap"
                      style={{ marginLeft: "auto", gap: "17.5px" }}
                    >
                      {!(
                        isAddendumBackPayItem(payItemVal) ||
                        isBackPayItem(payItemVal) ||
                        payrollTypes === "SP" ||
                        payItemVal === "Initial Salary(AP)" ||
                        payItemVal === "Last Salary(AP)" ||
                        (jobTypeVal === "Job Order" &&
                          payItemVal === "Last Salary")
                      ) && (
                        <div className="">
                          <style>
                            {`
                             .custom-range-picker .ant-picker-input input::placeholder {
                               color: grey;
                               opacity: 1;
                             }
                           `}
                          </style>
                          <Space direction="vertical" size={20}>
                            <RangePicker
                              style={{ width: "220px" }}
                              onChange={(date) =>
                                this.presenter.onChangeDate(date, objects)
                              }
                              className="custom-range-picker border p-2 fw-semibold"
                            />
                          </Space>
                        </div>
                      )}

                      <FileUpload
                        onFileUpload={(data) =>
                          this.presenter.handleCSVData(data)
                        }
                      />
                      <Button
                        onClick={() => this.presenter._handleModalContent()}
                        disabled={!canGenerate}
                      >
                        <i className="bi bi-arrow-clockwise" /> Generate
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                selectable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
                selected={selected}
                onSelect={(value) => this.presenter.onSelect(value)}
                onSelectAll={this.onSelectAll.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isFloatingForm && (
          <FormPayrollPage
            objects={tableObjects}
            closeFloating={() => this.presenter._handleToggling("close")}
            refetchData={this.refetchData.bind(this)}
            datePicked={this.state.datePicked}
            selectedTypes={{
              payrollTypes,
              payrollTypeVal,
              jobTypeVal,
              payItems,
              payItemVal,
              jobTypeID,
            }}
            otherInfo={{
              sg: this.state.salaryLevel,
              csv: this.state.csvData,
              attendance: this.state.attendance,
              numberOfDutiesinAP: this.state.personelAirportCount,
              monthIndex: this.state.monthIndex,
              payrollCode: this.state.payrollCode,
              percentage: this.state.percentage,
              periodCovered: this.state.periodCovered,
              selectedYear: this.state.selectedYear,
              twentyPercentYear: this.state.twentyPercentYear,
              incentiveId: this.state.incentiveId,
              natureOfFunction: this.state.natureOfFunction,
              monthFrom: this.state.monthFrom,
              monthTo: this.state.monthTo,
              caseName: this.state.caseName,
              ...this.state.panelState,
            }}
          />
        )}
        {this.state.isModalContent && (
          <ModalContent
            onClose={() => this.presenter._handleToggling()}
            onGenerate={() => this.presenter._handleGenerate()}
            onPayrollCode={(value) =>
              this.presenter._handleInputChange("payrollCode", value)
            }
            onPercentage={(value) =>
              this.presenter._handleInputChange("percentage", value)
            }
            onStartDate={(value) =>
              this.presenter._handleChangeDate(value, "start")
            }
            onEndDate={(value) =>
              this.presenter._handleChangeDate(value, "end")
            }
            onSelectYear={(value) =>
              this.presenter._handleInputChange("selectedYear", value)
            }
            onMonthFrom={(value) =>
              this.presenter._handleInputChange("monthFrom", value)
            }
            onMonthTo={(value) =>
              this.presenter._handleInputChange("monthTo", value)
            }
            selectedYear={(value) =>
              this.presenter._handleInputChange("twentyPercentYear", value)
            }
            selectedTypes={{
              payrollTypes,
              payItems,
            }}
          />
        )}
      </>
    );
  }
}

export default ProcessPayrollPage;
